/* eslint-disable */
import React, { useEffect, useState, useMemo } from 'react';
import NotificationService, { INotification } from 'src/services/notificationservice';
import {
  TableWrapper,
  ControlsContainer,
  Label,
  StyledTable,
  TableHead,
  TableBody,
  EmptyRow,
  LoadingText,
  ErrorText,
} from './styles';

const sortFunctions = {
  Date: (a: INotification, b: INotification) => Date.parse(b.date) - Date.parse(a.date),
  Manager: (a: INotification, b: INotification) => a.manager.localeCompare(b.manager),
};

const NotificationsTable: React.FC = () => {
  const [data, setData] = useState<INotification[]>([]);
  const [filterType, setFilterType] = useState<string>('');
  const [sortKey, setSortKey] = useState<'Date' | 'Manager'>('Date');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(null);
    NotificationService.fetchGlobalNotifications()
      .then(fetchedData => {
        if (!mounted) return;
        if (Array.isArray(fetchedData)) {
          setData(fetchedData);
        } else {
          setError('Invalid data format received');
        }
        setLoading(false);
      })
      .catch(err => {
        if (!mounted) return;
        setError(err.message || 'Failed to fetch notifications');
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  // Filtering and sorting the data
  const filteredSortedData = useMemo(() => {
    const filtered = filterType ? data.filter(item => item.type === filterType) : data;
    return filtered.slice().sort(sortFunctions[sortKey]);
  }, [data, filterType, sortKey]);

  if (loading) return <LoadingText>Loading notifications...</LoadingText>;
  if (error) return <ErrorText>Error: {error}</ErrorText>;

  return (
    <TableWrapper>
      <ControlsContainer>
        <Label>
          Filter by Type:
          <select value={filterType} onChange={e => setFilterType(e.target.value)}>
            <option value="Task">Task</option>
            <option value="Notification">Notification</option>
            <option value="Distribution">Distribution</option>
            <option value="New Hire">New Hire</option>
            <option value="Paystatements">Paystatements</option>
            <option value="W2 Forms">W2 Forms</option>
            <option value="Other">Other</option>
          </select>
        </Label>
      </ControlsContainer>
      <StyledTable>
        <TableHead>
          <tr>
            <th>Type</th>
            <th>Date</th>
            <th>Message</th>
            <th>Manage/Emp.</th>
          </tr>
        </TableHead>
        <TableBody>
          {filteredSortedData.length === 0 ? (
            <EmptyRow>
              <td colSpan={4}>No notifications available.</td>
            </EmptyRow>
          ) : (
            filteredSortedData.map(item => (
              <tr key={item.id}>
                <td>{item.type}</td>
                <td>{item.createdAt}</td>
                <td>{item.module}</td>
                <td style={{ textAlign: 'right' }}>{item.manager}</td>
              </tr>
            ))
          )}
        </TableBody>
      </StyledTable>
    </TableWrapper>
  );
};

export default NotificationsTable;
